import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions,URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { Angular2TokenService } from 'angular2-token';
import { AuthService } from '../../authentication/auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class FinanceService {

	options: RequestOptions;

  constructor(
  	private http: Http,
    private tokenService: Angular2TokenService,
    private authService: AuthService
  ) { 
  	this.options = this.authService.getHeaders();
  }

  private extractData(res: Response) {
    let body = res.json();
    return body;
  }

  private handleErrorObservable (error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.message || error);
  }

  getProjectList(){
  	let url = environment.apiBaseUrl+'/v1/proposals/boq_approved_project_list';
  	return this.http.get(url,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);
  }
  getProposalList(projectId){
    let url = environment.apiBaseUrl+'/v1/proposals/proposal_list_for_finance?project_id='+projectId;
    return this.http.get(url,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);
  }
  getBoqList(projectId){
    let url = environment.apiBaseUrl+'/v1/projects/'+projectId+'/approved_quotations';
    return this.http.get(url,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);
  }
  getPaymentDetails(projectId){
    let url = environment.apiBaseUrl+'/v1/projects/'+projectId+'/payments/payment_history';

    return this.http.get(url,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);
  }

  verifyPayment(paymentid){
    let url = environment.apiBaseUrl+'/v1/proposals/payment_approval_by_financiar';
    var obj={
      'payment_id':paymentid,
      'is_approved':'yes'
    }
    return this.http.post(url,obj,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);
  }
  approvePayments(projectId,paymentid,data){
    let url = environment.apiBaseUrl+'/v1/projects/'+projectId+'/payments/'+paymentid+'/payment_approval';
    return this.http.post(url,data,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);

  }
  getPaymentQuotation(projectId,paymentid){
    let url = environment.apiBaseUrl+'/v1/projects/'+projectId+'/payments/'+paymentid;
    return this.http.get(url,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);

  }

  approveBoq(projectId,boqid){
    let url = environment.apiBaseUrl+'/v1/projects/'+projectId+'/quotations/'+boqid+'/change_wip_status';
    var obj={
      'approve':true
    }
    return this.http.post(url,obj,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);
  }

  getPercentBoqs(project_id,state){
    let url = environment.apiBaseUrl+'/v1/proposals/quotation_types?project_id='+project_id+'&proposal_type='+state;
    return this.http.get(url,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);
  }

  getPaymentHistory(project_id,boq_id){
    let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/payments/boq_payment_history?boq_id='+boq_id;
    return this.http.get(url,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);
  }


}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/finance/finance.service.ts